// import './base.scss';
import '../public/base.js';

// import '@wangeditor/editor/dist/css/style.css'


import './element-variables.scss'

import '@fontsource/alata'

import request, {
	uploadFile,
	makeHeaders,
	makeSign
} from '@/utils/request.js'

window.request = request;
window.uploadFile = uploadFile;




import Vue from 'vue'
import ElementUI from 'element-ui';
// import 'element-ui/lib/theme-chalk/index.css';
import App from './App.vue';
import router from '@/router';
import store from './store';
import filter from '@/utils/filter'
import i18n from './lang' // 引入 i18n 配置

window.store = store;


window.addEventListener('resize', function() {
	store.state.sm = window.innerWidth < 992;
});


Vue.config.productionTip = false;

Vue.use(ElementUI);


Vue.filter('imageUrlFilter', (value) => {
	return value;
})



store.dispatch('initConfig', {});


store.dispatch('initLogin', {
	cb: () => {
		// window.app = new Vue({
		// 	store,
		// 	router,
		// 	i18n,
		// 	render: h => h(App)
		// }).$mount('#app')
	}
});

window.app = new Vue({
			store,
			router,
			i18n,
			render: h => h(App)
		}).$mount('#app')